import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-z5v4gv-0"
})(["display:flex;position:relative;flex-flow:column;flex-grow:1;flex-shrink:0;width:100%;border:", ";border-radius:", ";box-shadow:", ";box-shadow:0 2px 6px rgb(46 46 51 / 0.08),0 2px 4px rgb(229 229 229 / 0.8);margin-bottom:1rem;background:#fff;background-color:#fff;user-select:none;> div:last-child{margin-bottom:14px;}"], function (_ref) {
  var featuring = _ref.featuring,
    theme = _ref.theme;
  return featuring === 'advised' ? "2px solid ".concat(theme.colors.primary, ";") : featuring === 'sponsored' ? "2px solid ".concat(theme.colors.primary, ";") : featuring === 'winning' ? "2px solid ".concat(theme.colors.secondary, ";") : "1px solid rgb(229 229 229 / 0.8);";
}, function (_ref2) {
  var featuring = _ref2.featuring;
  return featuring === 'sponsored' ? '0 4px 4px 4px' : '4px';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadows.lightBlack;
});